import { Controller } from "stimulus";

class SimpleToggleController extends Controller {
  static targets = [ 'content' ]
  static classes = [ "hidden" ]

  toggle() {
    this.contentTargets.forEach((t) => t.classList.toggle(this.hiddenClass));
  }
}

export default SimpleToggleController;
